<template>
  <va-card :title="$t('menu.pallets')">
    <va-data-table
      :fields="fields"
      :data="pallet_types"
      :per-page="10"
    >

      <template slot="actions" slot-scope="props">
        <va-button
          small
          inline
          color="green"
          icon="fa fa-edit"
          class="ml-2"
          :to="{ name: 'form-pallets', params: { id: props.rowData.id } }"
        >
          {{ $t('menu.edit') }}
        </va-button>

        <va-button
          small
          inline
          color="success"
          icon="fa fa-cog"
          class="ml-2"
          :to="{ name: 'form-pallet-type-setup', params: { id: props.rowData.id, pallet_type_name: props.rowData.name } }"
        >
          {{ $t('menu.setup') }}
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import PalletTypeAPI from '@/services/PalletTypeAPI'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      pallet_types: [],
      locality_id: '',
    }
  },

  mounted () {
    this.locality_id = this.$store.state.currentLocality.id
    this.getPalletTypes(this.locality_id)
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),

    fields () {
      return [{
        name: 'name',
        title: this.$t('tables.mounting_flow.pallet_type'),
      },
      {
        name: 'minimum_assembly_time',
        title: this.$t('tables.pallets.minimum_assembly_time'),
      },
      {
        name: 'assembling_timeout',
        title: this.$t('tables.pallets.assembling_timeout'),
      },
      {
        name: 'sort_type',
        title: this.$t('tables.pallets.sort_type'),
      },
      {
        name: 'pallet_type_setup.quantity_limitation',
        title: this.$t('tables.pallet_type_setups.quantity_limitation'),
      },
      {
        name: 'pallet_type_setup.limit_quantity',
        title: this.$t('tables.pallet_type_setups.limit_quantity'),
      },
      {
        name: 'pallet_type_setup.specific_products',
        title: this.$t('tables.pallet_type_setups.specific_products'),
      },
      {
        name: 'pallet_type_setup.minimal_cubage',
        title: this.$t('tables.pallet_type_setups.minimal_cubage'),
      },
      {
        name: 'pallet_type_setup.maximal_cubage',
        title: this.$t('tables.pallet_type_setups.maximal_cubage'),
      },
      {
        name: 'pallet_type_setup.minimal_vehicle_percentage',
        title: this.$t('tables.pallet_type_setups.minimal_vehicle_percentage'),
      },
      {
        name: 'active',
        title: this.$t('tables.pallets.active'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },

  watch: {
    '$store.state.currentLocality': function () {
      this.locality_id = this.$store.state.currentLocality.id
      this.getPalletTypes(this.locality_id)
    },
  },

  methods: {
    async getPalletTypes (localityId) {
      await PalletTypeAPI.getByLocality(localityId).then(response => {
        this.pallet_types = response.data.pallet_types
      })
    },
  },
}
</script>
